(function(Drupal) {
  'use strict';

  Drupal.behaviors.contactAccordion = {
    attach: function(context, settings) {

      const slideDown = (element, duration = 300) => {
        element.style.display = 'grid'; // Changed to 'grid' for layout
        const height = element.scrollHeight;
        element.style.height = '0';
        element.style.overflow = 'hidden';
        element.style.transition = `height ${duration}ms ease`;

        setTimeout(() => {
          element.style.height = height + 'px';
        }, 10);

        setTimeout(() => {
          element.style.height = '';
          element.style.overflow = '';
          element.style.transition = '';
        }, duration);
      };

      const slideUp = (element, duration = 300) => {
        const height = element.scrollHeight;
        element.style.height = height + 'px';
        element.style.overflow = 'hidden';
        element.style.transition = `height ${duration}ms ease`;

        setTimeout(() => {
          element.style.height = '0';
        }, 10);

        setTimeout(() => {
          element.style.display = 'none';
          element.style.height = '';
          element.style.overflow = '';
          element.style.transition = '';
        }, duration);
      };

      const slideToggle = (element, duration = 300) => {
        if (element.style.display === 'none' || !element.style.display) {
          slideDown(element, duration);
        }
        else {
          slideUp(element, duration);
        }
      };

      // Target the accordion containers
      const containers = context.querySelectorAll('.view-display-id-block_accordion');

      containers.forEach(container => {

        // Check if already initialized
        if (container.hasAttribute('data-accordion-initialized')) {
          return;
        }
        container.setAttribute('data-accordion-initialized', 'true');

        const headers = container.querySelectorAll('h3');

        // Group consecutive .views-row elements after each h3
        headers.forEach(header => {
          const rowsGroup = [];
          let nextElement = header.nextElementSibling;

          // Collect all consecutive .views-row elements
          while (nextElement && nextElement.classList.contains('views-row')) {
            rowsGroup.push(nextElement);
            nextElement = nextElement.nextElementSibling;
          }

          // If there are rows to group, wrap them
          if (rowsGroup.length > 0) {
            // Create wrapper div
            const wrapper = document.createElement('div');
            wrapper.classList.add('accordion-content');
            wrapper.style.display = 'none';

            // Insert wrapper after the header
            header.parentNode.insertBefore(wrapper, rowsGroup[0]);

            // Move all rows into the wrapper
            rowsGroup.forEach(row => {
              wrapper.appendChild(row);
              row.style.display = 'block'; // Ensure rows are visible within wrapper
            });
          }
        });

        // Now get all headers again and their associated content wrappers
        const updatedHeaders = container.querySelectorAll('h3');
        const contentWrappers = container.querySelectorAll('.accordion-content');

        // Add accordion classes to headers
        updatedHeaders.forEach(header => {
          header.classList.add('accordion-header');
        });

        // Optional: Open first item by default
        if (updatedHeaders.length > 0 && contentWrappers.length > 0) {
          updatedHeaders[0].classList.add('active');
          contentWrappers[0].style.display = 'grid';
        }

        // Click handler for accordion headers
        updatedHeaders.forEach(header => {

          // Make headers keyboard accessible
          header.setAttribute('role', 'button');
          header.setAttribute('tabindex', '0');
          header.setAttribute('aria-expanded', 'false');

          // Click event
          header.addEventListener('click', function() {
            const content = this.nextElementSibling;

            if (!content || !content.classList.contains('accordion-content')) {
              return;
            }

            // Toggle current item
            this.classList.toggle('active');
            const isExpanded = this.classList.contains('active');
            this.setAttribute('aria-expanded', isExpanded);

            slideToggle(content, 300);

            // Optional: Close other items
            updatedHeaders.forEach(otherHeader => {
              if (otherHeader !== this) {
                otherHeader.classList.remove('active');
                otherHeader.setAttribute('aria-expanded', 'false');
                const otherContent = otherHeader.nextElementSibling;
                if (otherContent && otherContent.classList.contains('accordion-content') && otherContent.style.display !== 'none') {
                  slideUp(otherContent, 300);
                }
              }
            });
          });

          // Keyboard support
          header.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              this.click();
            }
          });
        });

        // Update aria-expanded on first item if opened by default
        if (updatedHeaders.length > 0) {
          updatedHeaders[0].setAttribute('aria-expanded', 'true');
        }
      });
    }
  };

})(Drupal);
